import packageJson from '../package.json'

export const DOMAIN = 'dfy.co.kr'
export const VERSION = `v${packageJson.version}`
